import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { useTranslation } from 'react-i18next';
import { LevelsConfigDialog } from '../config/LevelsConfigDialog';
import { useFeatures } from '../../../features/FeaturesContext';

export function EditLevelsConfig() {
  const { t } = useTranslation();
  const { features } = useFeatures();
  const { read: readLevelConfig } = features[Feature.LEVEL_CONFIG];
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title={readLevelConfig ? '' : t('shared.action.permission.required')}>
        <div>
          <Button
            startIcon={<FontAwesomeIcon icon={faBars} />}
            type="button"
            color="grey"
            onClick={() => setOpen(true)}
            sx={{ borderRadius: '50px' }}
            disabled={!readLevelConfig}
            id="level-settings-button-id"
          >
            {t('levels.configDialog.edit.button')}
          </Button>
        </div>
      </Tooltip>

      <LevelsConfigDialog open={open} setOpen={setOpen} />
    </>
  );
}
